import { gatewayInstance } from "../axiosInstance";

const buildParams = (userId, transporterIds = null) => {
  const params = new URLSearchParams();
  params.append("userId", userId);
  if (transporterIds && transporterIds.length > 0) {
    transporterIds.forEach((id) => params.append("transporterIds", id));
  }
  return params;
};

const buildDateParams = (userId, fromDate, toDate, transporterIds = null) => {
  const params = buildParams(userId, transporterIds);
  params.append("fromDate", fromDate);
  params.append("toDate", toDate);
  return params;
};

const parseResponse = (data) =>
  typeof data === "string" ? JSON.parse(data) : data;

export const getVehicleSummary = async (userId, transporterIds = null) => {
  const response = await gatewayInstance.get(
    "/analyticalservice/transporter-dashboard/vehicle-summary",
    { params: buildParams(userId, transporterIds) },
  );
  return parseResponse(response.data);
};

export const getMonthlyJobTrend = async (userId, transporterIds = null) => {
  const response = await gatewayInstance.get(
    "/analyticalservice/transporter-dashboard/monthly-job-trend",
    { params: buildParams(userId, transporterIds) },
  );
  return parseResponse(response.data);
};

export const getStatusWiseJob = async (userId, fromDate, toDate, transporterIds = null) => {
  const response = await gatewayInstance.get(
    "/analyticalservice/transporter-dashboard/status-wise-job",
    { params: buildDateParams(userId, fromDate, toDate, transporterIds) },
  );
  return parseResponse(response.data);
};

export const getFinanceStatistics = async (userId, fromDate, toDate, transporterIds = null) => {
  const response = await gatewayInstance.get(
    "/analyticalservice/transporter-dashboard/finance-statistics",
    { params: buildDateParams(userId, fromDate, toDate, transporterIds) },
  );
  return parseResponse(response.data);
};

export const getJobChargeableKm = async (userId, fromDate, toDate, transporterIds = null) => {
  const response = await gatewayInstance.get(
    "/analyticalservice/transporter-dashboard/job-chargeable-km",
    { params: buildDateParams(userId, fromDate, toDate, transporterIds) },
  );
  return parseResponse(response.data);
};